<template lang="pug">
#diagnostico-socioambiental
    el-collapse(v-model='indexCollapseRow', :accordion='!inspecionar')
        el-collapse-item(
            v-for='(diagnostico, index) in this.dadosConsulta.diagnostico || this.dadosConsulta.diagnosticos',
            :key='`diagnosticos-${index}`',
            v-if='showLayer(diagnostico)',
            :name='index'
        )
            template(slot='title')
                i.mr-2.flow.flow-verified.verde.mr8.custon-icon(
                    v-if='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "BAIXO") || (!diagnostico.nivelAlerta && diagnostico.resultados.length === 0 && !inspecionar)'
                )
                i.mr-2.flow.flow-warning-sign.amarelo.mr8.custon-icon(
                    v-else-if='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "MEDIO") || (!diagnostico.nivelAlerta && !inspecionar && habilitarSinalAviso)'
                )
                i.mr-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
                    v-else-if='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "ALTO") || (!diagnostico.nivelAlerta && !inspecionar)'
                )
                | {{ definirNomeCamada(diagnostico.camada) }}
                div(v-if='diagnostico.resultados.length')
                    el-tag.custon-tag(
                        v-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "BAIXO"',
                        size='mini',
                        type='success'
                    ) {{ diagnostico.resultados.length }}
                    el-tag.custon-tag(
                        v-else-if='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "MEDIO") || (!diagnostico.nivelAlerta && !inspecionar && habilitarSinalAviso)',
                        size='mini',
                        type='warning'
                    ) {{ diagnostico.resultados.length }}
                    el-tag.custon-tag(v-else, size='mini', type='danger') {{ diagnostico.resultados.length }}

            div(v-if='showLayerResults(diagnostico)')
                .card-opacidade(v-if='podeHabilitarOpacidade(diagnostico)')
                    .opacidade
                        span {{ $t('mensagens.diagnosticoSocioambiental.opacidade') }}:
                        el-slider(
                            v-model='diagnostico.camada.opacidade',
                            @change='atualizarOpacidade(diagnostico.camada.opacidade)'
                        )
                component(
                    ref='componente',
                    v-bind:is='diagnostico.component',
                    v-bind='getProperties(diagnostico)',
                    @aplicar-zoom-restricao='aplicarZoomRestricao'
                )
                    template(
                        v-if='habilitarInibicaoCamada',
                        v-slot:botaoInibir='{ restricao }'
                    )
                        .botao-inibir-restricao
                            el-button(
                                v-if='verificaPerfilBotaoInibir() && !ehRestricaoInibida(restricao)',
                                :class='!ehRestricaoInibida(restricao) ? "botao-inibir-restricao--nao-inibido" : ""',
                                @click='$emit("inibir-restricao", restricao, diagnostico)',
                                type='primary',
                                size='mini'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.inibir') }}
                            el-button(
                                v-if='verificaPerfilBotaoJustificativa() && ehRestricaoInibida(restricao)',
                                @click='$emit("inibir-restricao", restricao, diagnostico)',
                                type='primary',
                                size='mini'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.visualizarJustificativa') }}

            .container-restricao(v-if='diagnostico.resultados.length === 0')
                p {{ $t('mensagens.diagnosticoSocioambiental.naoHaRestricoes') }}

            Fonte(
                :fonte='diagnostico.camada.fonte || { dataCadastro: "-", nome: "-", url: "-" }'
            )
            el-button.float-right.my-3(
                type='primary',
                @click='getCertidao()',
                icon='el-icon-tickets',
                v-if='cpfCnpj && (diagnostico.camada.codigo === "AREA_EMBARGADA" || diagnostico.camada.codigo === "LISTA_AREA_EMBARGADA")'
            ) {{ $t('mensagens.diagnosticoSocioambiental.consultarCertidao') }}
            el-button.float-right.my-3(
                type='primary',
                @click='getCertidaoLdi()',
                icon='el-icon-tickets',
                v-if='car && diagnostico.camada.codigo === "LDI"'
            ) {{ $t('mensagens.diagnosticoSocioambiental.consultarCertidao') }}

            el-empty(
                v-if='!possuiResultados',
                :description='$t("mensagens.menuSig.semInformacoesCamadasSelecionadas")'
            )
</template>

<script>
import TerraIndigena from '@/components/diagnosticoSocioambiental/TerraIndigena.vue';
import TerraIndigenaParaguai from '@/components/diagnosticoSocioambiental/TerraIndigenaParaguai.vue';
import AmazoniaProtege from '@/components/diagnosticoSocioambiental/AmazoniaProtege.vue';
import AreaEmbargada from '@/components/diagnosticoSocioambiental/AreaEmbargada.vue';
import Prodes from '@/components/diagnosticoSocioambiental/Prodes.vue';
import AreaEmbargadaIcmbio from '@/components/diagnosticoSocioambiental/AreaEmbargadaIcmbio.vue';
import AreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/AreaEmbargadaSemaMt.vue';
import ListaAreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaSemaMt.vue';
import AreaEmbargadaGoias from '@/components/diagnosticoSocioambiental/AreaEmbargadaGoias';
import MoratoriaSoja from '@/components/diagnosticoSocioambiental/MoratoriaSoja.vue';
import MoratoriaSojaPontos from '@/components/diagnosticoSocioambiental/MoratoriaSojaPontos.vue';
import MoratoriaSojaConsolidada from '@/components/diagnosticoSocioambiental/MoratoriaSojaConsolidada.vue';
import PovosComunidadesTradicionais from '@/components/diagnosticoSocioambiental/PovosComunidadesTradicionais.vue';
import Ldi from '@/components/diagnosticoSocioambiental/Ldi.vue';
import ListaAreaEmbargada from '@/components/diagnosticoSocioambiental/ListaAreaEmbargada.vue';
import ProtocoloVerdeGraos from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraos.vue';
import ListaSujaTrabalhoEscravo from '@/components/diagnosticoSocioambiental/ListaSujaTrabalhoEscravo.vue';
import ProdesCerrado from '@/components/diagnosticoSocioambiental/ProdesCerrado.vue';
import DeterAmazonia from '@/components/diagnosticoSocioambiental/DeterAmazonia.vue';
import DeterCerrado from '@/components/diagnosticoSocioambiental/DeterCerrado.vue';
import UnidadeConservacaoUs from '@/components/diagnosticoSocioambiental/UnidadeConservacaoUs.vue';
import UnidadeConservacaoPi from '@/components/diagnosticoSocioambiental/UnidadeConservacaoPi.vue';
import Queimadas from '@/components/diagnosticoSocioambiental/Queimadas.vue';
import SitiosArqueologicos from '@/components/diagnosticoSocioambiental/SitiosArqueologicos.vue';
import FaixaFronteira from '@/components/diagnosticoSocioambiental/FaixaFronteira.vue';
import PocAreaPlantadaGameleira from '@/components/diagnosticoSocioambiental/PocAreaPlantadaGameleira.vue';
import ImovelRural from '@/components/diagnosticoSocioambiental/ImovelRural.vue';
import Biomas from '@/components/diagnosticoSocioambiental/Biomas.vue';
import IncraSigefPublico from '@/components/diagnosticoSocioambiental/IncraSigefPublico.vue';
import IncraSigefPrivado from '@/components/diagnosticoSocioambiental/IncraSigefPrivado.vue';
import IncraAssentamentos from '@/components/diagnosticoSocioambiental/IncraAssentamentos.vue';
import IncraQuilombolas from '@/components/diagnosticoSocioambiental/IncraQuilombolas.vue';
import QuilombolasMaranhao from '@/components/diagnosticoSocioambiental/QuilombolasMaranhao.vue';
import DesmatamentoMapbiomas from '@/components/diagnosticoSocioambiental/desmatamento-mapbiomas.vue';
import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import AreaRelevanteInteresseEcologicoArie from '@/components/diagnosticoSocioambiental/AreaRelevanteInteresseEcologicoArie.vue';
import AreaProtecaoAmbientalApa from '@/components/diagnosticoSocioambiental/AreaProtecaoAmbientalApa.vue';
import AppCamada from '@/components/diagnosticoSocioambiental/AppCamada.vue';
import ReservaLegal from '@/components/diagnosticoSocioambiental/ReservaLegal.vue';
import UnidadeConservacao from '@/components/diagnosticoSocioambiental/UnidadeConservacao.vue';
import AreaPlantadaSojaCarMapbiomas from '@/components/diagnosticoSocioambiental/AreaPlantadaSojaCarMapbiomas.vue';
import AreaEmbargadaSedamRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaSedamRo.vue';
import AreasSilvestresProtegidasParaguai from '@/components/diagnosticoSocioambiental/AreasSilvestresProtegidasParaguai.vue';
import AreaProdutiva2007Ap from '@/components/diagnosticoSocioambiental/AreaProdutiva2007Ap.vue';
import AreaProdutiva2007Vn from '@/components/diagnosticoSocioambiental/AreaProdutiva2007Vn.vue';
import AreaProdutiva2009 from '@/components/diagnosticoSocioambiental/AreaProdutiva2009.vue';
import AreaProdutiva2016 from '@/components/diagnosticoSocioambiental/AreaProdutiva2016.vue';
import AreaPlantadaVegetacaoNativa2022Milho from '@/components/diagnosticoSocioambiental/AreaPlantadaVegetacaoNativa2022Milho.vue';
import AreaPlantadaVegetacaoNativa2022Soja from '@/components/diagnosticoSocioambiental/AreaPlantadaVegetacaoNativa2022Soja.vue';
import AreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/AreaEmbargadaPiaui.vue';
import AreaEmbargadaSigaSemaMt from './AreaEmbargadaSigaSemaMt.vue';
import AreaEmbargadaSigaMtPoligono from './AreaEmbargadaSigaMtPoligono.vue';
import AreaEmbargadaSigaMtPonto from './AreaEmbargadaSigaMtPonto.vue';
import FundacaoPalmares from './FundacaoPalmares.vue';
import AutoInfracaoIpaam from './AutoInfracaoIpaam.vue';
import AreaEmbargadaGdf from './AreaEmbargadaGdf.vue';
import { camadasDiagnostico } from '@/constants/DiagnosticoSocioAmbientalCamadas';
import TermoEmbargoIpaam from './TermoEmbargoIpaam.vue';
import RedFlag from './RedFlag.vue';
import YellowFlag from './YellowFlag.vue';
import AreaEmbargadaParana from '@/components/diagnosticoSocioambiental/AreaEmbargadaParana.vue';
import TreeCanopyCoverTcc from './TreeCanopyCoverTcc.vue';
import ProdesPantanal from './ProdesPantanal.vue';
import ProdesMataAtlantica from './ProdesMataAtlantica.vue';
import ProdesPampa from './ProdesPampa.vue';
import ProdesCaatinga from './ProdesCaatinga.vue';
import AreaEmbargadaAutoInfracaoSp from './AreaEmbargadaAutoInfracaoSp.vue';
import FlorestasPublicas from './FlorestasPublicas.vue';
import AreaEmbargadaRs from './AreaEmbargadaRs.vue';
import AreaPlantadaBunge from './AreaPlantadaBunge.vue';
import { CamadasService } from '@/services/CamadasService';
import AreaEmbargadaGoPonto from './AreaEmbargadaGoPonto.vue';
import FincasParaguai from './FincasParaguai.vue';
import DesmatamentoInfonaParaguai from './DesmatamentoInfonaParaguai.vue';
import PastizalParaguai from './PastizalParaguai.vue';
import PastizalInundableParaguai from './PastizalInundableParaguai.vue';
import AreasEmbargadasTo from '@/components/diagnosticoSocioambiental/AreasEmbargadasTo.vue';
import AutoInfracaoTo from '@/components/diagnosticoSocioambiental/AutoInfracaoTo.vue';
import EmbargosGoLista from './EmbargosGoLista.vue';
import SojaParaguai2022 from './SojaParaguai2022.vue';
import ProdesResiduos from './ProdesResiduos.vue';
import ProdesResiduosAmazonia from './ProdesResiduosAmazonia.vue';
import ProdesResiduosCaatinga from './ProdesResiduosCaatinga.vue';
import ProdesResiduosCerrado from './ProdesResiduosCerrado.vue';
import ProdesResiduosMataAtlantica from './ProdesResiduosMataAtlantica.vue';
import ProdesResiduosPampa from './ProdesResiduosPampa.vue';
import ProdesResiduosPantanal from './ProdesResiduosPantanal.vue';
import ApriaReservaDeLaBiosfera from './ApriaReservaDeLaBiosfera.vue';
import AutoInfracaoRs from './AutoInfracaoRs.vue';
import QuilombolasBa from './QuilombolasBa.vue';
import AutoInfracaoPi from './AutoInfracaoPi.vue';
import AreaEmbargadaPa from './AreaEmbargadaPa.vue';
import EudrForestCover2020 from './EudrForestCover2020.vue';
import CsaCerrado from './CsaCerrado.vue';
import OtbnArgentina from './OtbnArgentina.vue';
import AppArgentinaPontos from './AppArgentinaPontos.vue';
import ApnSifap from './ApnSifap.vue';
import AppArgentinaPoligonos from './AppArgentinaPoligonos.vue';
import ApriaPatrimonioDaHumanidadPuntos from './ApriaPatrimonioDaHumanidadPuntos.vue';
import ApriaSitiosRamsar from './ApriaSitiosRamsar.vue';
import ApnAreaMarinaProtegida from './ApnAreaMarinaProtegida.vue';
import DesmatamentoArgentina from './DesmatamentoArgentina.vue';
import ReservaBiosferaParaguai from './ReservaBiosferaParaguai.vue';
import SitioRamsarParaguai from './SitioRamsarParaguai.vue';
import ReservaProvinciale from './ReservaProvinciale.vue';
import LocalidadeOnccaArgentina from './LocalidadeOnccaArgentina.vue';
import Prodes2008 from './Prodes2008.vue';
import Prodes2009 from './Prodes2009.vue';
import Prodes2010 from './Prodes2010.vue';
import Prodes2011 from './Prodes2011.vue';
import Prodes2012 from './Prodes2012.vue';
import Prodes2013 from './Prodes2013.vue';
import Prodes2014 from './Prodes2014.vue';
import Prodes2015 from './Prodes2015.vue';
import Prodes2016 from './Prodes2016.vue';
import Prodes2017 from './Prodes2017.vue';
import Prodes2018 from './Prodes2018.vue';
import Prodes2019 from './Prodes2019.vue';
import Prodes2020 from './Prodes2020.vue';
import Prodes2021 from './Prodes2021.vue';
import Prodes2022 from './Prodes2022.vue';
import Prodes2023 from './Prodes2023.vue';
import Prodes2024 from './Prodes2024.vue';
import ProdesCerrado2020 from './ProdesCerrado2020.vue';
import ProdesCerrado2021 from './ProdesCerrado2021.vue';
import ProdesCerrado2022 from './ProdesCerrado2022.vue';
import ProdesCerrado2023 from './ProdesCerrado2023.vue';
import ProdesCerrado2024 from './ProdesCerrado2024.vue';
import AreaPlantadaDesmatamentoVegaAPartir2021 from './AreaPlantadaDesmatamentoVegaAPartir2021.vue';
import EudrAreaPlantadaEmCoberturaFlorestal2020 from './EudrAreaPlantadaEmCoberturaFlorestal2020.vue';
// O nome dos componentes (arquivos) de camadas devem seguir o codigo da camada em CamelCase
// Exemplo do arquivo: camada codigo SIGEF_PUBLICO = SigefPublico.vue
// O atributo name dos componentes deve ser o codigo da camada separado por -
// Exemplo do name: camada codigo SIGEF_PUBLICO = sigef-publico

export default {
    name: 'DiagnosticoSocioambiental',

    emits: ['index-aberto', 'inibir-restricao'],

    components: {
        TerraIndigena,
        TerraIndigenaParaguai,
        AmazoniaProtege,
        AreaEmbargada,
        AreaPlantadaBunge,
        Prodes,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        AreaEmbargadaGoias,
        AreaEmbargadaPiaui,
        MoratoriaSoja,
        MoratoriaSojaPontos,
        MoratoriaSojaConsolidada,
        PovosComunidadesTradicionais,
        Ldi,
        ListaAreaEmbargada,
        ProtocoloVerdeGraos,
        ListaSujaTrabalhoEscravo,
        ProdesCerrado,
        DeterAmazonia,
        DeterCerrado,
        UnidadeConservacaoUs,
        UnidadeConservacaoPi,
        Queimadas,
        SitiosArqueologicos,
        FaixaFronteira,
        PocAreaPlantadaGameleira,
        ImovelRural,
        Biomas,
        IncraSigefPublico,
        IncraSigefPrivado,
        IncraAssentamentos,
        IncraQuilombolas,
        QuilombolasMaranhao,
        DesmatamentoMapbiomas,
        Fonte,
        AreaRelevanteInteresseEcologicoArie,
        AreaProtecaoAmbientalApa,
        AppCamada,
        ReservaLegal,
        UnidadeConservacao,
        AreaPlantadaSojaCarMapbiomas,
        AreaEmbargadaSedamRo,
        AreasSilvestresProtegidasParaguai,
        AreaProdutiva2007Ap,
        AreaProdutiva2007Vn,
        AreaProdutiva2009,
        AreaProdutiva2016,
        AreaPlantadaVegetacaoNativa2022Milho,
        AreaPlantadaVegetacaoNativa2022Soja,
        ListaAreaEmbargadaSemaMt,
        AreaEmbargadaSigaSemaMt,
        AreaEmbargadaSigaMtPoligono,
        AreaEmbargadaSigaMtPonto,
        FundacaoPalmares,
        AutoInfracaoIpaam,
        AreaEmbargadaGdf,
        TermoEmbargoIpaam,
        RedFlag,
        YellowFlag,
        AreaEmbargadaParana,
        TreeCanopyCoverTcc,
        ProdesPantanal,
        ProdesMataAtlantica,
        ProdesPampa,
        ProdesCaatinga,
        AreaEmbargadaAutoInfracaoSp,
        FlorestasPublicas,
        AreaEmbargadaRs,
        AreaEmbargadaGoPonto,
        FincasParaguai,
        DesmatamentoInfonaParaguai,
        PastizalParaguai,
        PastizalInundableParaguai,
        AreasEmbargadasTo,
        AutoInfracaoTo,
        EmbargosGoLista,
        SojaParaguai2022,
        ProdesResiduos,
        ProdesResiduosAmazonia,
        ProdesResiduosCaatinga,
        ProdesResiduosCerrado,
        ProdesResiduosMataAtlantica,
        ProdesResiduosPampa,
        ProdesResiduosPantanal,
        ApriaReservaDeLaBiosfera,
        AutoInfracaoRs,
        CsaCerrado,
        QuilombolasBa,
        AutoInfracaoPi,
        AreaEmbargadaPa,
        EudrForestCover2020,
        OtbnArgentina,
        AppArgentinaPontos,
        ApnSifap,
        AppArgentinaPoligonos,
        ApriaPatrimonioDaHumanidadPuntos,
        ApriaSitiosRamsar,
        ApnAreaMarinaProtegida,
        DesmatamentoArgentina,
        ReservaBiosferaParaguai,
        SitioRamsarParaguai,
        ReservaProvinciale,
        LocalidadeOnccaArgentina,
        Prodes2008,
        Prodes2009,
        Prodes2010,
        Prodes2011,
        Prodes2012,
        Prodes2013,
        Prodes2014,
        Prodes2015,
        Prodes2016,
        Prodes2017,
        Prodes2018,
        Prodes2019,
        Prodes2020,
        Prodes2021,
        Prodes2022,
        Prodes2023,
        Prodes2024,
        ProdesCerrado2020,
        ProdesCerrado2021,
        ProdesCerrado2022,
        ProdesCerrado2023,
        ProdesCerrado2024,
        AreaPlantadaDesmatamentoVegaAPartir2021,
        EudrAreaPlantadaEmCoberturaFlorestal2020
    },

    props: {
        dadosConsulta: {
            type: Object,
            required: true
        },
        inspecionar: {
            type: Boolean,
            required: false,
            default: false
        },

        indexCollapse: {
            type: Number,
            required: false,
            default: 0
        },

        cpfCnpj: {
            type: String,
            required: false,
            default: null
        },

        car: {
            type: String,
            required: false,
            default: null
        },

        habilitarSinalAviso: {
            type: Boolean,
            required: false,
            default: false
        },

        habilitarInibicaoCamada: {
            type: Boolean,
            required: false,
            default: false
        },
        habilitarOpacidade: {
            type: Boolean,
            required: false,
            default: false
        },
        mapaLeaflet: {
            type: Object,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            indexCollapseRow: '',
            possuiResultados: false,
            camadasUsuario: []
        };
    },

    watch: {
        indexCollapseRow: function () {
            this.$emit(
                'index-aberto',
                null,
                this.indexCollapse,
                this.indexCollapseRow
            );
        },
        dadosConsulta: function () {
            this.possuiResultados = false;
            this.filtrarCamadas();
        }
    },

    async mounted() {
        this.filtrarCamadas();
        try {
            const { data } = await CamadasService.buscarCamadasUsuario();
            this.camadasUsuario = data;

            if (this.inspecionar) {
                this.indexCollapseRow = Array.from(
                    { length: this.camadasUsuario.length },
                    (_, index) => index
                );
            }
            if (this.dadosConsulta.diagnostico) {
                this.dadosConsulta.diagnostico.forEach(diagnosticoCamada => {
                    diagnosticoCamada.resultados.forEach(item => {
                        item.selecionado = false;
                    });
                });
            }
        } catch (error) {
            this.$notify.error(
                'Ocorreu um erro ao buscar as camadas do usuário.'
            );
        }
    },

    methods: {
        verificaPerfilBotaoJustificativa() {
            return (
                this.$store.state.usuarioLogado.isAdmin ||
                this.$store.state.usuarioLogado.operacaoAprovador
            );
        },
        verificaPerfilBotaoInibir() {
            return this.$store.state.usuarioLogado.isAdmin;
        },
        ehRestricaoInibida(restricao) {
            return restricao.inibido;
        },
        atualizarOpacidade(opacidade) {
            const group = `grupo-restricoes-${this.indexCollapse}-${this.indexCollapseRow}`;
            const layers = Object.values(this.mapaLeaflet.mapa._layers).filter(
                l => l.group === group
            );
            if (layers) {
                const novaOpacidade = opacidade >= 0 ? opacidade / 200 : 0.5;
                layers.forEach(layer => {
                    this.mapaLeaflet.mapa.removeLayer(layer);
                    layer.options.fillOpacity = novaOpacidade;
                    layer.options.opacity = novaOpacidade;
                    this.mapaLeaflet.mapa.addLayer(layer);
                });
            }
        },
        filtrarCamadas() {
            if (this.dadosConsulta.diagnostico) {
                this.dadosConsulta.diagnostico =
                    this.dadosConsulta.diagnostico.filter(
                        ({ camada }) => camada.codigo !== 'APP_DEGRADADA'
                    );
                this.dadosConsulta.diagnostico.sort((a, b) => {
                    return a.camada.nome.localeCompare(b.camada.nome);
                });
            } else if (this.dadosConsulta.diagnosticos) {
                this.dadosConsulta.diagnosticos =
                    this.dadosConsulta.diagnosticos.filter(
                        ({ camada }) => camada.codigo !== 'APP_DEGRADADA'
                    );
                this.dadosConsulta.diagnosticos.sort((a, b) => {
                    return a.camada.nome.localeCompare(b.camada.nome);
                });
            }
        },
        showLayer(diagnostico) {
            if (diagnostico) {
                if (
                    this.cpfCnpj &&
                    diagnostico.camada.codigo === 'AREA_EMBARGADA_GOIAS'
                ) {
                    return false;
                } else {
                    const show = this.inspecionar
                        ? this.camadasUsuario.includes(
                              diagnostico.camada.codigo
                          ) && diagnostico.resultados.length > 0
                        : camadasDiagnostico.includes(
                              diagnostico.camada.codigo
                          );
                    if (show) {
                        this.possuiResultados = true;
                    }
                    return show;
                }
            }
            return false;
        },
        showLayerResults(diagnostico) {
            if (diagnostico && diagnostico.resultados.length) {
                if (diagnostico.camada.codigo === 'APP') {
                    diagnostico.component = 'app-camada';
                } else {
                    diagnostico.component = diagnostico.camada.codigo
                        .toLowerCase()
                        .replaceAll('_', '-');
                }
                return true;
            }
            return false;
        },
        getProperties(diagnostico) {
            return {
                restricoes: diagnostico.resultados,
                geometria: diagnostico.geometria,
                habilitarZoomRestricao: this.habilitarZoomRestricao,
                cpfCnpj: this.cpfCnpj
            };
        },
        async getCertidao() {
            const fmtCpfCnpj = this.cpfCnpj
                .replaceAll('-', '')
                .replaceAll('.', '');
            const url = `https://servicos.ibama.gov.br/ctf/publico/areasembargadas/ConsultaPublicaAreasEmbargadas.php?modulo=publico/areasembargadas/CertidaoNadaConsta.php&$bvars=${fmtCpfCnpj}&ajax=1&fpdf=1`;
            window.open(url, '_blank');
        },
        async getCertidaoLdi() {
            const url = `https://monitoramento.semas.pa.gov.br/ldi/imoveis/downloadcertidaodesmatamento?codigoImovel=${this.car}`;
            window.open(url, '_blank');
        },
        definirNomeCamada({ codigo, nome }) {
            return codigo === 'MORATORIA_SOJA_PONTOS'
                ? 'Moratória Soja - Lista'
                : nome;
        },

        podeHabilitarOpacidade(diagnostico) {
            let podeHabilitar = false;

            /**
             * Caso a props esteja 'false'
             * o componente de opacidade não vai ser exibido
             */
            if (!this.habilitarOpacidade) {
                return podeHabilitar;
            }

            /**
             * Verifica se existe restrições com
             * geometria para exibir a opacidade
             */
            if (diagnostico) {
                if (diagnostico.geometria && diagnostico.geometria.length) {
                    podeHabilitar = true;
                } else if (diagnostico.resultados.length) {
                    const totalRestricoesSemGeometria =
                        diagnostico.resultados.filter(resultado => {
                            if (resultado.properties) {
                                if (
                                    resultado.properties.geometry ||
                                    resultado.properties.geometria
                                ) {
                                    return false;
                                }
                            }

                            if (resultado.propriedade) {
                                if (
                                    resultado.propriedade.geometry ||
                                    resultado.propriedade.geometria
                                ) {
                                    return false;
                                }
                            }

                            if (resultado.geometry || resultado.geometria) {
                                return false;
                            }

                            // Se retornar true é por que não tem geometria
                            return true;
                        }).length;
                    if (
                        totalRestricoesSemGeometria !==
                        diagnostico.resultados.length
                    ) {
                        podeHabilitar = true;
                    }
                }
            }

            return podeHabilitar;
        },

        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes,
            index
        ) {
            let geoJson = geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                typeof restricao.properties === 'object' &&
                restricao.properties
            ) {
                if (restricao.properties.geometry) {
                    geoJson = restricao.properties.geometry;
                }

                if (restricao.properties.geometria) {
                    geoJson = restricao.properties.geometria;
                }
            }

            if (
                typeof restricao.propriedade === 'object' &&
                restricao.propriedade
            ) {
                if (restricao.propriedade.geometry) {
                    geoJson = restricao.propriedade.geometry;
                }

                if (restricao.propriedade.geometria) {
                    geoJson = restricao.propriedade.geometria;
                }
            }

            if (restricao.geometry) {
                geoJson = restricao.geometry;
            }
            if (restricao.geometria) {
                geoJson = restricao.geometria;
            }

            const group = Object.values(this.mapaLeaflet.mapa._layers).filter(
                d =>
                    d.group ===
                    `grupo-restricoes-${this.indexCollapse}-${this.indexCollapseRow}`
            );

            group.forEach(layer => {
                layer.setStyle({
                    color: 'red',
                    weight: 1,
                    fill: true
                });
            });

            const layer = Object.values(this.mapaLeaflet.mapa._layers).find(
                d =>
                    d.name ===
                    `AreaDiagnostico_red_${this.indexCollapse}_${this.indexCollapseRow}_${index}`
            );

            if (layer) {
                layer.setStyle({
                    color: 'orange',
                    weight: 1,
                    fill: true
                });
            }

            this.mapaLeaflet.aplicarZoomGeoJson(geoJson);
        }
    }
};
</script>

<style lang="scss">
#diagnostico-socioambiental .container-restricao {
    p {
        line-height: 1.7692307692 !important;
    }

    .card-restricao {
        background-color: #fafafa;
        border: 1px solid #eaeefb;
        border-radius: 4px;
        padding: 10px 10px 0px 20px;
        margin-bottom: 20px;
    }

    .card-restricao--ativo {
        border: 1px solid var(--primary);
    }

    .container-restricao-acoes {
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
    }
}

.vermelho {
    color: red;
}

.amarelo {
    color: #d7bc25;
}

.verde {
    color: green;
}

.certidao {
    color: var(--white) !important;
    background: var(--primary) !important;
}

.custon-tag {
    border-radius: 12px;
    margin-left: 5px;
}

.custon-icon {
    font-size: 16px;
}

.el-tag--mini {
    height: 17px !important;
    padding: 0 5px !important;
    line-height: 17px !important;
    border-radius: 10px !important;
}

.botao-inibir-restricao {
    display: flex;
    justify-content: flex-end;

    .botao-inibir-restricao--nao-inibido {
        margin-right: 10px;
    }
}

.camada-inibida {
    background: #f2f2f2;
    border-radius: 5px;
    padding: 10px 15px;
    margin-left: -20px !important;
    margin-bottom: 15px;
}
.card-opacidade {
    margin-bottom: 20px !important;
    word-wrap: break-word !important;
    background-color: #fff !important;
    background-clip: border-box !important;
    border: 1px solid rgba(0, 0, 0, 0.13) !important;
    border-radius: 0.25rem !important;
    padding: 5px !important;
    .opacidade {
        display: block;
        padding: 0 20px;
        span {
            font-weight: bolder;
        }
        .el-slider {
            width: 97%;
            height: 20px;
        }
    }
}
</style>
